export default __webpack_public_path__ + "static/media/ExpressPay.f57871ba.png";